var _circle, _g, _g2, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataFlowCircular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 600,
    viewBox: "0 0 800 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 300,
    r: 50,
    fill: "rgba(0, 255, 213, 0.3)",
    stroke: "#00ffd5",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "50;55;50",
    dur: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    values: "0.3;0.4;0.3",
    dur: "2s",
    repeatCount: "indefinite"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "nodes"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 150,
    r: 15,
    fill: "rgba(0, 255, 213, 0.2)",
    stroke: "#00ffd5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530,
    cy: 175,
    r: 15,
    fill: "rgba(0, 255, 213, 0.2)",
    stroke: "#00ffd5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 615,
    cy: 250,
    r: 15,
    fill: "rgba(0, 255, 213, 0.2)",
    stroke: "#00ffd5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 300,
    r: 15,
    fill: "rgba(0, 255, 213, 0.2)",
    stroke: "#00ffd5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 615,
    cy: 350,
    r: 15,
    fill: "rgba(0, 255, 213, 0.2)",
    stroke: "#00ffd5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530,
    cy: 425,
    r: 15,
    fill: "rgba(0, 255, 213, 0.2)",
    stroke: "#00ffd5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 450,
    r: 15,
    fill: "rgba(0, 255, 213, 0.2)",
    stroke: "#00ffd5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 425,
    r: 15,
    fill: "rgba(0, 255, 213, 0.2)",
    stroke: "#00ffd5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 350,
    r: 15,
    fill: "rgba(0, 255, 213, 0.2)",
    stroke: "#00ffd5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 300,
    r: 15,
    fill: "rgba(0, 255, 213, 0.2)",
    stroke: "#00ffd5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 250,
    r: 15,
    fill: "rgba(0, 255, 213, 0.2)",
    stroke: "#00ffd5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 175,
    r: 15,
    fill: "rgba(0, 255, 213, 0.2)",
    stroke: "#00ffd5",
    strokeWidth: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "connections"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400 150L400 300",
    stroke: "#00ffd5",
    strokeWidth: 2,
    strokeDasharray: "5 3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-16",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M530 175L400 300",
    stroke: "#00ffd5",
    strokeWidth: 2,
    strokeDasharray: "5 3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-16",
    dur: "1s",
    begin: "0.1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M615 250L400 300",
    stroke: "#00ffd5",
    strokeWidth: 2,
    strokeDasharray: "5 3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-16",
    dur: "1s",
    begin: "0.2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M650 300L400 300",
    stroke: "#00ffd5",
    strokeWidth: 2,
    strokeDasharray: "5 3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-16",
    dur: "1s",
    begin: "0.3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M615 350L400 300",
    stroke: "#00ffd5",
    strokeWidth: 2,
    strokeDasharray: "5 3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-16",
    dur: "1s",
    begin: "0.4s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M530 425L400 300",
    stroke: "#00ffd5",
    strokeWidth: 2,
    strokeDasharray: "5 3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-16",
    dur: "1s",
    begin: "0.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M400 450L400 300",
    stroke: "#00ffd5",
    strokeWidth: 2,
    strokeDasharray: "5 3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-16",
    dur: "1s",
    begin: "0.6s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M270 425L400 300",
    stroke: "#00ffd5",
    strokeWidth: 2,
    strokeDasharray: "5 3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-16",
    dur: "1s",
    begin: "0.7s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M185 350L400 300",
    stroke: "#00ffd5",
    strokeWidth: 2,
    strokeDasharray: "5 3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-16",
    dur: "1s",
    begin: "0.8s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M150 300L400 300",
    stroke: "#00ffd5",
    strokeWidth: 2,
    strokeDasharray: "5 3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-16",
    dur: "1s",
    begin: "0.9s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M185 250L400 300",
    stroke: "#00ffd5",
    strokeWidth: 2,
    strokeDasharray: "5 3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-16",
    dur: "1s",
    begin: "1.0s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M270 175L400 300",
    stroke: "#00ffd5",
    strokeWidth: 2,
    strokeDasharray: "5 3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-16",
    dur: "1s",
    begin: "1.1s",
    repeatCount: "indefinite"
  })))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 300,
    r: 60,
    fill: "rgba(0, 255, 213, 0.1)",
    filter: "blur(10px)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "60;70;60",
    dur: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    values: "0.1;0.2;0.1",
    dur: "2s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataFlowCircular);
export default __webpack_public_path__ + "static/media/data-flow-circular.9ecb19bdadf3ac965e5919241e58a24b.svg";
export { ForwardRef as ReactComponent };